import { getUserPersona } from "@/utils/helper.js"

const isObjectEmpty = objectName => {
  return Object.keys(objectName).length === 0
}

export const getPersonaPriceDetails = priceDtl => {
  const persona = getUserPersona()
  const result = []
  if (priceDtl?.prices) {
    const filerPrice =
      priceDtl?.prices?.filter(elemet => !isObjectEmpty(elemet?.prices)) || []
    filerPrice?.map(price => {
      if (Object.keys(price?.prices) !== 0) {
        result.push({
          currencySign: price?.currencySign ? price?.currencySign : $,
          sku: price?.sku,
          discountedPrice: Object.values(price?.discountPrices).length
            ? (price?.discountPrices[persona]?.centAmount / 100).toFixed(2)
            : null,
          price: price?.prices[persona]
            ? (price?.prices[persona]?.centAmount / 100).toFixed(2)
            : null,
          pricelist: price?.prices["ANY"]
            ? (price?.prices["ANY"]?.centAmount / 100).toFixed(2)
            : null,
        })
      }
    })
  }

  return result
}

export const getProductCartQuantity = (listColor, cart, productId) => {
  let mapColor
  if (listColor) {
    const list = listColor.map(color => {
      const d = color.split("|")
      return {
        sku: d[2].split("-")[0],
      }
    })
    mapColor = [...new Set(list.map(item => item.sku))]
  }
  const isAdded = cart?.lineItems?.filter(item => {
    const itemID = item.variant?.sku.split("-")[0]
    return mapColor?.includes(itemID) || productId === itemID
  })

  const totalQunatity = isAdded?.reduce((sum, item) => sum + item.quantity, 0)
  const isAddedFlag = isAdded?.[0] ? true : false
  return { isAddedFlag, totalQunatity }
}

export const getStockItems = args => {
  let stock = false
  let discontuned = false
  let outofStock = false
  args?.forEach(val => {
    const isDiscontinudItems = val?.discontinued
    const isStock = val?.isStock === "true" || val?.isStock === undefined
    if (isDiscontinudItems) {
      discontuned = true
    } else if (isStock) {
      stock = true
    } else {
      outofStock = true
    }
  })
  return { stock, discontuned, outofStock, sku: args[0]?.sku }
}
